<template>
	<div>
		<efly-screen v-if="type === 'normal'">
			<div slot="label">
				<efly-select downIcon="icon-down2" size="small" width="100px" type="screen"
							 :value="label"></efly-select>
			</div>
			<slot>
				<div class="efly-input efly-input-small box flex-align-center" style="width: 300px">
					<input readonly :id="startTimeID" placeholder="请选择开始时间"
						   class="efly-input flex"/>
					<span class="mar-lr-xs">-</span>
					<input readonly :id="endTimeID" placeholder="请选择结束时间"
						   class="efly-input flex"/>
				</div>
			</slot>
		</efly-screen>
		<div class="list-advanced-search-item" v-if="type === 'advanced'">
			<div class="list-advanced-search-item-label">{{label}}：</div>
			<div class="efly-input efly-input-small box flex-align-center" style="width: 400px">
				<input readonly :id="startTimeID" placeholder="开始时间"
					   class="efly-input flex"/>
				<span class="mar-lr-xs">-</span>
				<input readonly :id="endTimeID" placeholder="结束时间"
					   class="efly-input flex"/>
			</div>
		</div>
	</div>
</template>

<script>
    import SelectTime from "./select-time";

    export default SelectTime;
</script>


<style scoped>

</style>
